import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { event: String }

    dispatch() {
        window.dispatchEvent(new CustomEvent(this.eventValue))
    }
}
